var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1631 20C12.4106 20 13.646 19.7543 14.7986 19.2769C15.9512 18.7994 16.9984 18.0997 17.8806 17.2175C18.7628 16.3354 19.4625 15.2881 19.9399 14.1355C20.4174 12.9829 20.6631 11.7476 20.6631 10.5C20.6631 9.25244 20.4174 8.0171 19.9399 6.86451C19.4625 5.71191 18.7628 4.66464 17.8806 3.78249C16.9984 2.90033 15.9512 2.20056 14.7986 1.72314C13.646 1.24572 12.4106 1 11.1631 1C8.64353 1 6.22717 2.00089 4.44557 3.78249C2.66398 5.56408 1.66309 7.98044 1.66309 10.5C1.66309 13.0196 2.66398 15.4359 4.44557 17.2175C6.22717 18.9991 8.64353 20 11.1631 20Z",
    stroke: "#0B1775",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6631 21L19.6631 19",
    stroke: "#0A0C2B",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.980f0464d80134bd97404a8e8eb2c23f.svg";
export { ForwardRef as ReactComponent };